import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ClientService } from '../../client.service';
import { GetResponse, Installation, ListResponse } from '../../models';
import { EquipmentApi } from '../equipment/equipment.api';

import { UpdateUserRequest, User, UserInstallationsParams, UserV2 } from './users.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class UsersApi {
  private readonly version = 'v1';

  constructor(private clientService: ClientService, private equipmentApi: EquipmentApi) {}

  getUser(uuid: string, httpHeaders?: HttpHeaders): Observable<UserV2> {
    const endpoint = `users/v2/users/${uuid}`;

    return this.clientService.get(endpoint, {}, httpHeaders);
  }

  /**
   * Get details of installation a user is assigned to
   * @param token
   * @param version
   */
  getUserInstallations(
    viAccount: string,
    _params: UserInstallationsParams = {},
    version: string = this.version
  ): Observable<ListResponse<Installation>> {
    const endpoint = `general-management/${version}/users/${viAccount}/installations`;

    return this.clientService.get(endpoint);
  }

  /**
   * Get user installations with gateways list
   * @param viAccount
   * @param params
   * @param version
   */
  getUserGateways(
    viAccount: string,
    params: UserInstallationsParams = {},
    version: string = this.version
  ): Observable<ListResponse<Installation>> {
    return this.getUserInstallations(viAccount, params, version).pipe(
      switchMap((response) =>
        forkJoin(
          response.data.map((installation) =>
            this.equipmentApi
              .getInstallation(installation.id)
              .pipe(catchError(() => of({ data: null })))
          )
        ).pipe(
          map((installations) => ({
            paging: response.paging,
            data: installations.map((i) => i.data),
          }))
        )
      )
    );
  }

  /**
   * Update an user
   * @param payload
   * @param version
   */
  updateUser(
    viAccount: string,
    payload: UpdateUserRequest,
    version: string = this.version
  ): Observable<GetResponse<User>> {
    const endpoint = `iot/${version}/user-management/users/${viAccount}`;

    return this.clientService.put(endpoint, payload);
  }
}
